import React from 'react';
import { Modal, Spinner } from "react-bootstrap";


// Displays a spinner hour glass for long loading situation
// *** Please note: this component cannot be used on top of another Modal
// Testing: You can use this to test API: res = await axios.post(apiURL + "/long-wait", reqBody);
export function LoadingSpinner(props) {

  const css = `
      .modal-content {
        border: 0 none;
        background-color: transparent;
      }
  `;

  return (
    <>
      <style>
        {css}
      </style>
      <Modal show={props.loading} centered >
        <div style={{width: '100%',
                    border: 'none',
                    backgroundColor: 'transparent',
                    textAlign: 'center'}}>
          <Spinner animation="border" variant="info"></Spinner>
        </div>
      </Modal>
    </>
  )
}

// Displays a spinner hour glass for long loading situation on another Modal
// You can use this in conjunction of <fieldset disabled={loading}> </fieldset>
// to disable the form fields while loading.
// Testing: You can use this to test API: res = await axios.post(apiURL + "/long-wait", reqBody);
export function LoadingSpinnerForModal(props) {

  return (
    props.loading ?
      <div style={{
        position: 'absolute',
        backgroundColor: 'transparent',
        backgroundRepeat: 'no-repeat',
        border: 'none',
        outline: 'none',
        shadow: 'none',
        left: '50%',
        top: '50%'
      }}>
        <Spinner animation="border" variant="info"></Spinner>
      </div>
    :
      null
  )
}


export function validateEmail(email) {
  let checker = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return (checker.test(email));
}


// Check to see if the user possesses any of the permissions in the permCodeList.
// If checkAdmin is true, then check to see if this is the system admin user
export function hasAnyPerm(user, permCodeList, checkAdmin) {

  if (   !user
      || !user.userInfo
      || !user.userInfo.permissions) {
    return (false);
  }

  for (let i=0; i<permCodeList.length; i++) {
    if (user.userInfo.permissions.includes(permCodeList[i])) {
      return (true);
    }
  }

  if (checkAdmin && (user.userInfo.username === 'SYSTEM')) {
    return (true);
  }

  return (false);
}
